import { DetailedBudgetCategoryBase } from './base/detailed-budget-category-base';

export class DetailedBudgetCategory extends DetailedBudgetCategoryBase { }